module.exports = __webpack_public_path__ + "img/rongYu7.d6ece14f.png";